import axios from 'axios';

import { AgentChatMessageDto, AgentChatThreadDto } from '../models/agent-chat.interfaces';

class AgentChatService {
  async getThread(limit?: number, before?: number): Promise<AgentChatThreadDto> {
    const { data } = await axios.get<AgentChatThreadDto>('agent-chat/thread', { params: { limit, before } });

    return data;
  }

  async sendMessage(content: string): Promise<AgentChatMessageDto> {
    const { data } = await axios.post<AgentChatMessageDto>('agent-chat/messages', { content });

    return data;
  }
}

export default new AgentChatService();
